import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useCommerceOverride } from '@atlassian/commerce-environment';
import { stateGuard } from '../../common/utils/state';
import { loadStripe } from '../stripe-js';
/**
 * @internal NOT EXPECTED to be use by a consumer
 * initializes Stripe API
 * to be used with {@link CreditCardFormState}
 * @param token - Stripe API token
 */
export var useStripeService = function useStripeService(token, options) {
  var intl = useIntl();
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    stripe = _useState2[0],
    setStripe = _useState2[1];
  var _useState3 = useState('loading'),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  var stripeLoader = useCommerceOverride(loadStripe);
  useEffect(function () {
    var cancelled = false;
    if (token !== undefined) {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _stripe;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return stripeLoader(token, _objectSpread({
                locale: intl.locale
              }, options));
            case 3:
              _stripe = _context.sent;
              if (!cancelled) {
                if (_stripe) {
                  setStripe(_stripe);
                  setState('complete');
                } else {
                  setState('error');
                }
              }
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              if (!cancelled) {
                setState('error');
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }))();
    }
    return function () {
      cancelled = true;
    };
  }, [stripeLoader, intl, token, options]);
  return stateGuard(stripe, state, undefined);
};